import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { OpportunityRequirement } from '@features/opportunities/modules/core/models/schema-property-definition';
import { OpportunityType } from '@shared/models/opportunity';

export type OpportunityMissingRequirements = {
  [key: string]:
    | OpportunityRequirement.ValueRequirement
    | OpportunityMissingRequirements;
};

export interface OpportunityRequirementOptions {
  requirementMode: OpportunityRequirement.Mode;
  requirements: OpportunityMissingRequirements;
  opportunityType: OpportunityType;
}

@Injectable({
  providedIn: 'root'
})
export class RequirementService {
  private readonly DEFAULT_REQUIREMENT_MODE =
    OpportunityRequirement.Mode.Application;

  private _options: OpportunityRequirementOptions = {
    opportunityType: 'Home',
    requirements: {},
    requirementMode: this.DEFAULT_REQUIREMENT_MODE
  };
  public get options() {
    return this._options;
  }
  public get mode() {
    return this._options.requirementMode;
  }
  private readonly optionsSubject = new BehaviorSubject(this._options);
  public readonly options$ = this.optionsSubject.asObservable();

  update(options: OpportunityRequirementOptions) {
    this._options = options;
    this.optionsSubject.next(options);
  }
}
